export const DEVELOPMENT_BOARD_MCUS = [
  'bit_c_pro',
  'blackpill_f401',
  'blackpill_f411',
  'blok',
  'bluepill',
  'bonsai_c4',
  'elite_c',
  'elite_pi',
  'helios',
  'imera',
  'kb2040',
  'liatris',
  'michi',
  'promicro',
  'promicro_rp2040',
  'proton_c',
  'stemcell',
  'svlinky',
];

export const INTEGRATED_MCUS = [
  'AT32F415',
  'at90usb1286',
  'at90usb1287',
  'at90usb162',
  'at90usb646',
  'at90usb647',
  'atmega16u2',
  'atmega16u4',
  'atmega328',
  'atmega328p',
  'atmega32a',
  'atmega32u2',
  'atmega32u4',
  'attiny85',
  'GD32VF103',
  'MK20DX128',
  'MK20DX256',
  'MK64FX512',
  'MK66FX1M0',
  'MKL26Z64',
  'RP2040',
  'STM32F042',
  'STM32F072',
  'STM32F103',
  'STM32F303',
  'STM32F401',
  'STM32F405',
  'STM32F407',
  'STM32F411',
  'STM32F446',
  'STM32G0B1',
  'STM32G431',
  'STM32G474',
  'STM32H723',
  'STM32H733',
  'STM32L412',
  'STM32L422',
  'STM32L432',
  'STM32L433',
  'STM32L442',
  'STM32L443',
  'WB32F3G71',
  'WB32FQ95',
];

export const MCU2BOOTLOADER: Record<string, string> = {
  RP2040: 'rp2040',
  MKL26Z64: 'halfkay',
  MK20DX128: 'halfkay',
  MK20DX256: 'halfkay',
  MK66FX1M0: 'halfkay',
  STM32F042: 'stm32-dfu',
  STM32F072: 'stm32-dfu',
  STM32F103: 'stm32duino',
  STM32F303: 'stm32-dfu',
  STM32F401: 'stm32-dfu',
  STM32F405: 'stm32-dfu',
  STM32F407: 'stm32-dfu',
  STM32F411: 'stm32-dfu',
  STM32F446: 'stm32-dfu',
  STM32G0B1: 'stm32-dfu',
  STM32G431: 'stm32-dfu',
  STM32G474: 'stm32-dfu',
  STM32H723: 'stm32-dfu',
  STM32H733: 'stm32-dfu',
  STM32L412: 'stm32-dfu',
  STM32L422: 'stm32-dfu',
  STM32L432: 'stm32-dfu',
  STM32L433: 'stm32-dfu',
  STM32L442: 'stm32-dfu',
  STM32L443: 'stm32-dfu',
  GD32VF103: 'gd32v-dfu',
  WB32F3G71: 'wb32-dfu',
  WB32FQ95: 'wb32-dfu',
  AT32F415: 'at32-dfu',
  atmega16u2: 'atmel-dfu',
  atmega32u2: 'atmel-dfu',
  atmega16u4: 'atmel-dfu',
  atmega32u4: 'atmel-dfu',
  at90usb162: 'atmel-dfu',
  at90usb646: 'atmel-dfu',
  at90usb647: 'atmel-dfu',
  at90usb1286: 'atmel-dfu',
  at90usb1287: 'atmel-dfu',
  atmega32a: 'bootloadhid',
  atmega328p: 'usbasploader',
  atmega328: 'usbasploader',
};
